<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- Cabeçalho da página -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="page-title mb-0 font-size-18">Gerenciamento de Termos de Uso</h4>
          </div>
        </div>
      </div>

      <!-- Conteúdo principal com abas -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <b-tabs v-model="abaAtiva" content-class="mt-3">
                
                <!-- Aba de Listagem -->
                <b-tab title="Listar Termos" active>
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0">Termos Cadastrados</h5>
                    <b-button 
                      variant="primary" 
                      @click="abaAtiva = 1; editandoTermos = false; formulario = { id: null, content: '' }; resetValidacao()"
                      size="sm"
                    >
                      <i class="fas fa-plus mr-1"></i>
                      Novo Termos
                    </b-button>
                  </div>

                  <!-- Filtros -->
                  <div class="row mb-3">
                    <div class="col-md-3">
                      <b-form-select
                        v-model="filtros.status"
                        :options="opcoesStatus"
                        size="sm"
                        @change="filtrarTermos"
                      />
                    </div>
                  </div>

                  <!-- Tabela de termos -->
                  <b-table
                    :fields="camposTabela"
                    :items="termosFiltrados"
                    :busy="carregando"
                    striped
                    hover
                    show-empty
                    empty-text="Sem termos encontrados"
                    responsive
                  >
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Carregando...</strong>
                      </div>
                    </template>

                    <template #cell(status)="data">
                      <b-badge :variant="data.item.is_active ? 'success' : 'secondary'">
                        {{ data.item.is_active ? 'Ativo' : 'Inativo' }}
                      </b-badge>
                    </template>

                    <template #cell(created_at)="data">
                      {{ formatarData(data.item.created_at) }}
                    </template>

                    <template #cell(acoes)="data">
                      <div class="btn-group btn-group-sm">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          @click="visualizarTermos(data.item)"
                          title="Visualizar"
                        >
                          <i class="fas fa-eye"></i>
                        </b-button>
                        <b-button
                          v-if="data.item.is_active"
                          variant="outline-primary"
                          size="sm"
                          @click="editarTermos(data.item)"
                          title="Editar"
                        >
                          <i class="fas fa-edit"></i>
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-tab>

                <!-- Aba de Cadastro/Edição -->
                <b-tab title="Cadastrar Termos">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0">{{ editandoTermos ? 'Editar Termos' : 'Novo Termos' }}</h5>
                    <b-button
                      variant="outline-secondary"
                      @click="cancelarEdicao"
                      size="sm"
                    >
                      <i class="fas fa-arrow-left mr-1"></i>
                      Voltar à Listagem
                    </b-button>
                  </div>

                  <b-form @submit.prevent="salvarTermos">
                    <div class="row">
                      <!-- Editor de Conteúdo -->
                      <div class="col-lg-6">
                        <b-form-group label="Conteúdo do Termos:*" label-for="conteudo">
                          <div class="ckeditor-container">
                            <ckeditor
                              :editor="editor"
                              v-model="formulario.content"
                              :config="editorConfig"
                              @ready="onEditorReady"
                              @focus="onEditorFocus"
                              @blur="onEditorBlur"
                              @input="onEditorInput"
                            />
                          </div>
                          <b-form-invalid-feedback :state="validacao.content" style="display: block;">
                            Conteúdo é obrigatório
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                      <!-- Preview do Conteúdo -->
                      <div class="col-lg-6">
                        <b-form-group label="Preview do Termos:">
                          <div class="preview-container border p-3 rounded bg-light">
                            <div 
                              v-if="formulario.content && formulario.content.trim()"
                              v-html="formulario.content"
                              class="preview-content"
                            ></div>
                            <div 
                              v-else 
                              class="text-muted text-center py-5"
                            >
                              <i class="fas fa-eye fa-2x mb-2"></i>
                              <p class="mb-0">Digite o conteúdo do termos para ver o preview</p>
                            </div>
                          </div>
                        </b-form-group>
                      </div>
                    </div>

                    <!-- Botões de ação -->
                    <div class="d-flex justify-content-end mt-4">
                      <b-button 
                        variant="outline-secondary" 
                        class="mr-2"
                        @click="cancelarEdicao"
                      >
                        <i class="fas fa-times mr-1"></i>
                        Cancelar
                      </b-button>
                      <b-button 
                        type="submit"
                        variant="primary"
                        :disabled="salvando"
                      >
                        <b-spinner v-if="salvando" small class="mr-1"></b-spinner>
                        <i v-else class="fas fa-save mr-1"></i>
                        {{ editandoTermos ? 'Atualizar' : 'Salvar' }}
                      </b-button>
                    </div>
                  </b-form>
                </b-tab>

                <!-- Aba de Usuários que Aceitaram os Termos -->
                <b-tab title="Usuários que Assinaram">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <strong>{{ $t('Usuários que assinaram os termos') }}</strong>
                      </div>
                    </div>

                    <load v-if="assinantesLoading" mode="table" message="Carregando assinantes" />

                    <div v-else>
                      <b-table small :items="assinantesList" :fields="assinantesFields" responsive="sm" bordered>
                        <template #cell(tecnico)="row">
                          <div>
                            <div class="font-weight-bold">{{ row.item.tecnico.nome }}</div>
                            <div class="text-muted small">{{ row.item.tecnico.email }}</div>
                          </div>
                        </template>

                        <template #cell(termos)="row">
                          <div>{{ row.item.termos_uso.version }}</div>
                        </template>

                        <template #cell(assinado_em)="row">
                          <div>{{ row.item.assinado_em }}</div>
                        </template>

                        <template #empty>
                          <div class="text-center my-4">
                            <h5 class="mb-0">{{ $t('No records found') }}</h5>
                          </div>
                        </template>
                      </b-table>

                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="per_page"
                              v-on:change="carregarAssinantes"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="pagination.per_page"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.current_page }}
                            {{ $t("of") }}
                            {{ pagination.last_page }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'TermosUsoRead',
  
  data() {
    return {
      abaAtiva: 0,
      
      carregando: false,
      salvando: false,
      editandoTermos: false,
      
      termos: [],
      termosFiltrados: [],
      termosVisualizacao: null,
      
      formulario: {
        id: null,
        content: ''
      },
      
      validacao: {
        content: null
      },
      
      filtros: {
        status: ''
      },
      
      // Configurações da tabela
      camposTabela: [
        { key: 'version', label: 'Versão', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'created_at', label: 'Data Criação', sortable: true },
        { key: 'acoes', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ],
      
      // Opções para filtros
      opcoesStatus: [
        { value: '', text: 'Todos os status' },
        { value: 'ativo', text: 'Apenas Ativos' },
        { value: 'inativo', text: 'Apenas Inativos' }
      ],
      page: 1,
      per_page: 10,
      pagination: {
        current_page: 0,
        per_page: 0,
        total: 0,
        last_page: 0,
      },
      assinantesList: [],
      assinantesLoading: false,
      assinantesFields: [
        { key: 'tecnico', label: 'Técnico', sortable: false },
        { key: 'termos', label: 'Termo (versão)', sortable: false },
        { key: 'assinado_em', label: 'Assinado em', sortable: false },
      ],
      assinanteVisualizacao: null,
      
      // CKEditor
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'undo',
            'redo',
            '|',
            'link',
            'blockQuote',
            'insertTable',
            '|',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'alignment',
            '|',
            'removeFormat'
          ]
        },
        language: 'pt-br',
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        },
        placeholder: 'Digite o conteúdo do termos de uso...',
        removePlugins: ['MediaEmbed']
      }
    };
  },
  mounted() {
    this.carregarTermos();
    this.carregarAssinantes();
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.pagination.last_page && page !== this.page) {
        this.page = page;
        this.carregarAssinantes();
      }
    },
    async carregarAssinantes() {
      try {
        this.assinantesLoading = true;
        const response = await axios.get('/api/dashboard/termos-assinados', {
          params: {
            page: this.page,
            per_page: this.per_page
          }
        });
        this.assinantesList = Array.isArray(response.data.data) ? response.data.data : (response.data || []);
        this.pagination = response.data.pagination;

        if (this.pagination.last_page < this.pagination.current_page) {
          this.page = this.pagination.last_page;
          this.carregarAssinantes();
        }
      } catch (error) {
        swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Erro ao carregar usuários que assinaram os termos',
          showConfirmButton: false,
          timer: 3000
        });
      } finally {
        this.assinantesLoading = false;
      }
    },
    async carregarTermos() {
      try {
        this.carregando = true;
        const response = await axios.get('/api/dashboard/termos-uso');
        this.termos = response.data.data || response.data;
        this.filtrarTermos();
      } catch (error) {
        console.error('Erro ao carregar termos:', error);
        swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Erro ao carregar termos de uso',
          showConfirmButton: false,
          timer: 3000
        });
      } finally {
        this.carregando = false;
      }
    },
    
    filtrarTermos() {
      let termosFilter = [...this.termos];
      
      if (this.filtros.status) {
        if (this.filtros.status === 'ativo') {
          termosFilter = termosFilter.filter(termo => termo.is_active);
        } else if (this.filtros.status === 'inativo') {
          termosFilter = termosFilter.filter(termo => !termo.is_active);
        }
      }
      
      this.termosFiltrados = termosFilter;
    },
    
    async salvarTermos() {
      if (!this.validarFormulario()) {
        return;
      }
      
      try {
        this.salvando = true;
        
        const dados = {
          content: this.formulario.content
        };
        
        let response;
        if (this.editandoTermos) {
          response = await axios.put(`/api/dashboard/termos-uso/${this.formulario.id}`, dados);
          swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Termos atualizado com sucesso!',
            showConfirmButton: false,
            timer: 3000
          });
        } else {
          response = await axios.post('/api/dashboard/termos-uso', dados);
          swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Termos cadastrado com sucesso!',
            showConfirmButton: false,
            timer: 3000
          });
        }
        
        this.cancelarEdicao();
        this.carregarTermos();
        
      } catch (error) {
        console.error('Erro ao salvar termos:', error);
        const errorMessage = error.response?.data?.message || 'Erro ao salvar termos de uso';
        swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: errorMessage,
          showConfirmButton: false,
          timer: 3000
        });
      } finally {
        this.salvando = false;
      }
    },
    
    editarTermos(termos) {
      this.editandoTermos = true;
      this.formulario = {
        id: termos.id,
        content: termos.content
      };
      this.resetValidacao();
      this.abaAtiva = 1;
    },

    visualizarTermos(termos) {
      this.termosVisualizacao = termos;
      this.$bvModal.show('modal-visualizar');
    },
    
    cancelarEdicao() {
      this.editandoTermos = false;
      this.formulario = {
        id: null,
        content: ''
      };
      this.resetValidacao();
      this.abaAtiva = 0;
    },
    
    validarFormulario() {
      let valido = true;
      
      if (!this.formulario.content || !this.formulario.content.trim()) {
        this.validacao.content = false;
        valido = false;
      } else {
        this.validacao.content = true;
      }
      
      if (!valido) {
        swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'warning',
          title: 'Por favor, preencha o conteúdo do termos',
          showConfirmButton: false,
          timer: 3000
        });
      }
      
      return valido;
    },
    resetValidacao() {
      this.validacao = {
        content: null
      };
    },
    
    formatarData(data) {
      if (!data) return 'N/A';
      
      try {
        return new Date(data).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return 'Data inválida';
      }
    },
    
    // Eventos do CKEditor
    onEditorReady(editor) {
      console.log('CKEditor está pronto para uso!', editor);
    },
    
    onEditorFocus(event, editor) {
      // Editor ganhou foco
    },
    
    onEditorBlur(event, editor) {
      // Editor perdeu foco - validar conteúdo
      if (this.formulario.content && this.formulario.content.trim()) {
        this.validacao.content = true;
      }
    },
    
    onEditorInput(content) {
      // Atualiza o preview em tempo real
      // O v-model já cuida da atualização automática
    }
  }
};
</script>

<style scoped>
.page-content {
  padding: 20px 0;
}

.ckeditor-container {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  min-height: 300px;
}

.ckeditor-container:focus-within {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-group-sm .btn {
  margin-right: 2px;
}

.btn-group-sm .btn:last-child {
  margin-right: 0;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.badge {
  font-size: 0.75em;
}

.table td {
  vertical-align: middle;
}

/* CKEditor customization */
.ck-editor__editable {
  min-height: 250px;
}

.ck-editor__editable:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Preview container styles */
.preview-container {
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
}

.preview-content {
  line-height: 1.6;
}

.preview-content h1, .preview-content h2, .preview-content h3, 
.preview-content h4, .preview-content h5, .preview-content h6 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.preview-content p {
  margin-bottom: 0.75rem;
}

.preview-content ul, .preview-content ol {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.preview-content table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.preview-content table td, .preview-content table th {
  border: 1px solid #dee2e6;
  padding: 0.5rem;
}

.preview-content table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .page-title-box {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .page-title-right {
    margin-top: 10px;
  }
  
  .btn-group-sm {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .btn-group-sm .btn {
    margin-right: 0;
    margin-bottom: 2px;
  }
}
</style>